// src/pages/Dashboard.js
import React, { useState } from 'react';
import GradeManager from '../components/GradeManager'; // We will create this next
import SubjectManager from '../components/SubjectManager';
import TopicManager from '../components/TopicManager';
import QuestionManager from '../components/QuestionManager';
import QuestionBank from '../components/QuestionBank';
import AdminDashboard from '../components/AdminDashboard';
import QuestionBankSearch from '../components/QuestionBankSearch';
import PrintableManager from '../components/PrintableManager';
import { Activity, LayoutDashboard, GraduationCap, BookOpen, LogOut, PlusCircle, Database, Medal, Gauge, Search, Printer } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import ActivityManager from '../components/ActivityManager';

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState('dashboard');

  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = '/login';
  };

  const onGradeSelected = (gradeId) => {
    setActiveTab('subjects');
    localStorage.setItem('dash-lastGrade', gradeId); // Store selected grade for SubjectManager
    // You can also pass the selected gradeId to SubjectManager via context or a global state if needed
  };

  return (
    <div style={{ display: 'flex', height: '100vh', backgroundColor: '#f8fafc' }}>
      {/* Sidebar */}
      <div style={{ width: '260px', backgroundColor: '#0f172a', color: 'white', padding: '1.5rem', display: 'flex', flexDirection: 'column' }}>
        <h2 style={{ fontSize: '1.25rem', marginBottom: '2rem', color: '#3b82f6' }}>Admin</h2>

        <nav style={{ flex: 1 }}>
          <SidebarItem icon={<Gauge size={20} />} label="Dashboard" active={activeTab === 'dashboard'} onClick={() => setActiveTab('dashboard')} />
          <SidebarItem icon={<GraduationCap size={20} />} label="Grades" active={activeTab === 'grades'} onClick={() => setActiveTab('grades')} />
          <SidebarItem icon={<BookOpen size={20} />} label="Subjects" active={activeTab === 'subjects'} onClick={() => setActiveTab('subjects')} />
          <SidebarItem icon={<LayoutDashboard size={20} />} label="Topics" active={activeTab === 'topics'} onClick={() => setActiveTab('topics')} />
          <SidebarItem icon={<PlusCircle size={20} />} label="Add Question" active={activeTab === 'questions'} onClick={() => setActiveTab('questions')} />
          <SidebarItem icon={<Database size={20} />} label="Question Bank" active={activeTab === 'questionBank'} onClick={() => setActiveTab('questionBank')} />
          <SidebarItem
            icon={<Search size={20} />}
            label="Question Search"
            active={activeTab === 'search'}
            onClick={() => setActiveTab('search')}
          />
          <SidebarItem icon={<Medal size={20} />} label="Badges" onClick={() => navigate('/badges')} />
          <SidebarItem icon={<Medal size={20} />} label="Review Queue" onClick={() => navigate('/question-review-queue')} />
          <SidebarItem
            icon={<Printer size={20} />}
            label="Printables"
            active={activeTab === 'printables'}
            onClick={() => setActiveTab('printables')}
          />
          <SidebarItem
            icon={<Activity size={20} />}
            label="User Activity"
            active={activeTab === 'activity'}
            onClick={() => setActiveTab('activity')}
          />
        </nav>

        <button onClick={handleLogout} style={{ display: 'flex', alignItems: 'center', gap: '10px', background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', padding: '10px' }}>
          <LogOut size={20} /> Logout
        </button>
      </div>

      {/* Content Area */}
      <div style={{ flex: 1, padding: '2rem', overflowY: 'auto' }}>
        {activeTab === 'dashboard' && <AdminDashboard />}
        {activeTab === 'grades' && <GradeManager onGradeSelected={onGradeSelected} />}
        {activeTab === 'subjects' && <SubjectManager />}
        {activeTab === 'topics' && <TopicManager />}
        {activeTab === 'questions' && <QuestionManager />}
        {activeTab === 'questionBank' && <QuestionBank />}
        {activeTab === 'search' && <QuestionBankSearch />}
        {activeTab === 'printables' && <PrintableManager />}
        {activeTab === 'activity' && <ActivityManager />}
      </div>
    </div>
  );
};

// Helper component for Sidebar links
const SidebarItem = ({ icon, label, active, onClick }) => (
  <div
    onClick={onClick}
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      padding: '12px',
      borderRadius: '8px',
      cursor: 'pointer',
      backgroundColor: active ? '#1e293b' : 'transparent',
      color: active ? '#3b82f6' : '#94a3b8',
      marginBottom: '8px'
    }}
  >
    {icon} {label}
  </div>
);

export default Dashboard;